<template>
    <div class="app-container">
      <el-row class="headTop">
        <el-col :span="2" :offset="22">
          <el-button style="width:100%"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
        </el-col>
      </el-row>
    <el-dialog title="赛事管理"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
          <el-form-item label="分店" prop="shopNum">
            <el-select v-model="formparams.shopNum" placeholder="请选择">
                <el-option
                v-for="item in this.shopList"
                :key="item.shopNum"
                :label="item.name"
                :value="item.shopNum"
                ></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="赛事标题" prop="title">
            <el-input class="w220" v-model="formparams.title" placeholder="请输入赛事标题"></el-input>
          </el-form-item>
         
          <el-form-item label="报名时间" prop="date">
            <el-date-picker
              v-model="date2"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
           <el-form-item label="活动时间" prop="date">
            <el-date-picker
              v-model="date"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-row>
            <el-col :span="10">
              <el-form-item label="最大队伍数量" prop="teamNumber">
                <el-input class="w220" v-model.number="formparams.teamNumber" placeholder="请输入最大队伍数量"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="每队最大成员" prop="teamPeopleNumber">
                <el-input class="w220" v-model.number="formparams.teamPeopleNumber" placeholder="请输入每队最大成员"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          
          <el-form-item label="宣传海报" required ref="uploadElement" prop="">
            <el-upload
              :class="{uploaderNone:hideUpload}"
              action="aa"
              ref="upload"
              list-type="picture-card"
              :auto-upload="false"
              :http-request="uploadFile"
              :file-list="fileList"
              multiple
              :limit="1"
              :on-change="onChange"
              :on-remove="handleRemove"
              accept="image/png,image/gif,image/jpg,image/jpeg"
              >
              <i class="el-icon-plus"></i>
            </el-upload>
            *提示*：为了更好的用户体验，图片请提供230*230像素，文件大小不超过500kb。
          </el-form-item>
          <el-form-item label="上/下线" required>
            <el-switch
              v-model="formparams.status"
              active-text="上线"
              inactive-text="下线">
            </el-switch>
          </el-form-item>
          <el-form-item label="赛事说明" prop="info">
            <editor-bar v-model="formparams.info" :isClear="isClear"></editor-bar>
            <!-- <el-input @click="this.dialogVisible2=true" v-model="formparams.info" placeholder="请输入赛事说明"></el-input> -->
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="title" label="赛事名称" width="140"></el-table-column>
         <el-table-column label="宣传海报" width="140">
          <template slot-scope="scope">
            <img class="imgList" style="width:120px;height:60px" :src="'http://zlesp.zlydgy.cn:8091/images/'+scope.row.imgurl" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="registstarttime"  label="报名开始时间"></el-table-column>
        <el-table-column prop="registendtime"  label="报名结束时间"></el-table-column>
        <el-table-column prop="releasetime" label="活动开始时间"></el-table-column>
        <el-table-column prop="endtime" label="活动结束时间"></el-table-column>  
        <el-table-column prop="teamnumber" label="最大队伍数" width="100"></el-table-column>
        <el-table-column prop="teampeoplenumber" label="每队人数" width="100"></el-table-column>
        <el-table-column label="分店名称" width="100">
          <template slot-scope="scope">
            <div> {{scope.row.shopNum|caseType}} </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="50">
          <template slot-scope="scope">
            <div v-if="scope.row.status=='1'">上线</div>
            <div v-if="scope.row.status=='0'">下线</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" v-if="scope.row.state == 0" @click="edit(scope.row)">编辑</el-button>
            <el-button type="info" v-if="scope.row.state == 2">已过期</el-button>

            <el-button type="success" v-if="scope.row.status == '0'&&scope.row.state!=2" @click="changeStatus(scope.row)">上线</el-button>
            <el-button type="danger" v-if="scope.row.status == '1'&&scope.row.state!=2" @click="changeStatus(scope.row)">下线</el-button>
            <el-button type="warning" @click="gositeListInfo(scope.row)">团队详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination" style="display:none">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {getEventHistory, insertEventHistory, getShops } from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
import EditorBar from '../../components/wangEnduit'
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      dialogVisible2: false,
      hideUpload: false,
      isClear: false,
      detail:"",
      date:[],//活动开始
      date2:[],//活动报名时间
      rules:{
        
        title:[
          { required: true, message: '请输入赛事标题', trigger: 'blur' }
        ],
        info:[
          { required: true, message: '请输入赛事说明', trigger: 'blur' }
        ],
        workStartTime:[
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        shopNum:[
          { required: true, message: '请选择分店', trigger: 'change' }
        ],
        teamNumber:[
          { required: true, message: '输入不能为空'},
          { type: 'number',min:1, message: '输入的必须为大于0的数字值'}
        ],
        teamPeopleNumber:[
          { required: true, message: '输入不能为空'},
          { type: 'number',min:1, message: '输入的必须为大于0的数字值'}
        ],
        date: [
          {
            type: "array",
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (this.date[0] != "") {
                callback();
              } else {
                callback(new Error("请选择日期"));
              }
            }
          }
        ]
      },
      startTime:'',
      endTime:'',
      timeList:[],
      addType:1,
      formparams:{
        title:'',
        info:'',//赛事说明
        releaseTime:'',//发布时间
        endTime:'',//结束时间
        registStartTime:'',//报名开始时间
        registEndTime:'',//报名结束时间
        teamNumber:'',//最大队伍数量
        shopNum:'',//分店编号
        teamPeopleNumber:'',//每对最大成员数
        status:0
      },
      formData:{},
      fileList:[],//图片回显示
      tableData:[],
      optionsJL:[],//私教列表
      classProject:[],//团课项目
      roomList:[],
      titleList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  components: {
    mainHead,
    EditorBar
  },
  beforeCreate(){
    that = this;
  },
  created(){
    this.getShopsList()
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    getTableList(){
      getEventHistory(this.params).then((res)=>{
        if(res.msg == "success"){
            this.tableData = res.data
        }
        this.loading = false
      })
    },
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        sessionStorage.setItem('shopList',JSON.stringify(res.data))
        if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
          this.formparams.shopNum = this.shopList[0].shopNum
        }
      })
    },
    showDialog(){
      
      this.dialogVisible =true
      this.clearForm('formparams')
      this.hideUpload = false
      this.addType = 1
      this.formparams.status = false
      this.formparams.title='',
      this.formparams.info='',//赛事说明
      this.formparams.releaseTime='',//发布时间
      this.formparams.endTime='',//结束时间
      this.formparams.registStartTime='',//报名开始时间
      this.formparams.registEndTime='',//报名结束时间
      this.formparams.teamNumber='',//最大队伍数量
      this.formparams.shopNum='',//分店编号
      this.formparams.teamPeopleNumber=''//每对最大成员数
      this.fileList=[]
      this.date=[]
      this.date2=[]
    },
    gositeListInfo(row){
      this.$router.push({path:'/gameModule/gameIteminfo',query:{id:row.id}})
    },
    //编辑
    edit(row){
      this.addType = 2
      console.log(row)
      this.dialogVisible = true
      this.formparams.id = row.id
      this.formparams.title=row.title,
      this.formparams.status = row.status
      if(row.status==1){
        this.formparams.status=true
      }else{
        this.formparams.status=false

      }
      this.formparams.info=row.info,//赛事说明
      this.date=[row.releasetime,row.endtime]
      this.date2=[row.registstarttime,row.registendtime]
      this.formparams.releaseTime=row.releasetime,//发布时间
      this.formparams.endTime=row.endtime,//结束时间
      this.formparams.registStartTime=row.registstarttime,//报名开始时间
      this.formparams.registEndTime=row.registendtime,//报名结束时间
      this.formparams.teamNumber=row.teamnumber,//最大队伍数量
      // this.formparams.shopNum=row.shopnum,//分店编号
      this.formparams.teamPeopleNumber=row.teampeoplenumber//每对最大成员数
      this.formparams.shopNum = row.shopNum
      this.formparams.showUnit= row.showUnit
      this.fileList=[]
      this.fileList.push({url:'http://zlesp.zlydgy.cn:8091/images/'+row.imgurl})
      if(this.fileList.length){
        this.hideUpload = true
      } else {
        this.hideUpload = false
      }
      this.clearForm('formparams')
    },
    handleRemove(fileList) {
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    onChange(file, fileList){
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    uploadFile(file){
      this.formData.append('uploadFile', file.file);
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if(this.$refs.upload.uploadFiles.length==0){
          this.$message.error('宣传海报不能为空');
          return
        } else {
          if(this.$refs.upload.uploadFiles[0].size/1024>500){
            this.$message.error('上传图片大小不能超过500kb');
            this.fileList= []
            this.hideUpload = false
            return
          }
          if(this.$refs.upload.uploadFiles[0].name){
            let nameARR = this.$refs.upload.uploadFiles[0].name.split('.')
            var re;
            re =  /^[A-Za-z0-9]+$/g;
            if (!re.test(nameARR[0])) {
              this.$message.error('上传图片名称只能是数字字母组合');
              this.fileList= []
              this.hideUpload= false
              return
            }
          }
        }
        if (valid) {
          console.log(this.date)
          this.formparams.releaseTime = this.date[0].trim();
          this.formparams.endTime = this.date[1].trim();
          this.formparams.registStartTime = this.date2[0].trim();
          this.formparams.registEndTime = this.date2[1].trim();
          if( this.formparams.status==true){
            this.formparams.status=1
          }else{
            this.formparams.status=0
          }
          if(this.addType ==1){
            this.formData = new FormData()
            this.$refs.upload.submit();
            this.formData.append('title', this.formparams.title);
            this.formData.append('status', this.formparams.status);
            this.formData.append('info', this.formparams.info);
            this.formData.append('releaseTime', this.formparams.releaseTime);
            this.formData.append('endTime', this.formparams.endTime);
            this.formData.append('registStartTime', this.formparams.registStartTime);
            this.formData.append('registEndTime', this.formparams.registEndTime);
            this.formData.append('teamNumber', this.formparams.teamNumber);
            this.formData.append('shopNum', this.formparams.shopNum);
            this.formData.append('teamPeopleNumber', this.formparams.teamPeopleNumber);
           
            let config = {
                headers: {
                  'Content-Type':'multipart/form-data',
                  'token':sessionStorage.getItem('token')
                }
            }
            this.$http.post('event/insertEventHistory', this.formData, config).then((res)=>{
              console.log(res)
              if(res.data.msg == 'success'){
                this.dialogVisible = false
                this.$message({
                  type:'success',
                  message:'添加成功'
                })
              }
              this.getTableList()
            })
          } else {
            this.formparams.releaseTime = this.date[0].trim();
            this.formparams.endTime = this.date[1].trim();
            this.formparams.registStartTime = this.date2[0].trim();
            this.formparams.registEndTime = this.date2[1].trim();
            this.formData = new FormData()
            this.$refs.upload.submit();
            this.formData.append('id', this.formparams.id);
            this.formData.append('title', this.formparams.title);
            this.formData.append('info', this.formparams.info);
            this.formData.append('releaseTime', this.formparams.releaseTime);
            this.formData.append('endTime', this.formparams.endTime);
            this.formData.append('registStartTime', this.formparams.registStartTime);
            this.formData.append('registEndTime', this.formparams.registEndTime);
            this.formData.append('teamNumber', this.formparams.teamNumber);
            this.formData.append('shopNum', this.formparams.shopNum);
            this.formData.append('status', this.formparams.status);
            this.formData.append('teamPeopleNumber', this.formparams.teamPeopleNumber);
            let config = {
                headers: {
                  'Content-Type':'multipart/form-data',
                  'token':sessionStorage.getItem('token')
                }
            }
            this.$http.post('event/updateEventHistory', this.formData, config).then((res)=>{
              console.log(res)
              if(res.data.msg == 'success'){
                this.dialogVisible = false
                this.$message({
                  type:'success',
                  message:'修改成功'
                })
              }
              this.getTableList()
            })
          }
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    changeStatus(row){
        this.formData = new FormData()
        // this.$refs.upload.submit();
        var status = ''
        console.log(row.status)
        if(row.status==1){
          status = 0
        } else {
          status = 1
        }
        this.formData.append('id', row.id);
        this.formData.append('status', status);
        let config = {
            headers: {
              'Content-Type':'multipart/form-data',
              'token':sessionStorage.getItem('token')
            }
        }
        this.$http.post('event/updateEventHistory', this.formData, config).then((res)=>{
          console.log(res)
          if(res.data.msg == 'success'){
            this.dialogVisible = false
            this.$message({
              type:'success',
              message:'修改成功'
            })
          }
          this.getTableList()
        })
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
    clearForm(formName) {
      if(this.$refs[formName]!=undefined){
        this.$refs[formName].clearValidate();
      }
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getTableList()
    },
  }
};
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// gameList.vue?678558ee